// Converte un data URL base64 in File (ngx-image-cropper v6 emette solo base64
// nell'ImageCroppedEvent; prima le versioni vecchie fornivano .file).
export function dataUrlToFile(dataUrl: string, filename: string): File | null {
	if (!dataUrl) { return null; }
	const parts = dataUrl.split(',');
	const mimeMatch = parts[0].match(/:(.*?);/);
	const mime = mimeMatch ? mimeMatch[1] : 'image/png';
	const binary = atob(parts[1]);
	let n = binary.length;
	const u8 = new Uint8Array(n);
	while (n--) {
		u8[n] = binary.charCodeAt(n);
	}
	return new File([u8], filename, { type: mime });
}
